var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.67 19.55V4l-4.611 7.555 4.61 7.994zm-5.05-7.292 4.524 7.599H6.27l4.35-7.6zm5.05 8.784v7.511H11.06l4.61-7.51zm-.307-.57H6.271l4.35 7.73 4.743-7.73zm-5.359 8.081H1l4.656-7.51 4.348 7.51zm6.325-9.004V4l4.611 7.555-4.61 7.994zm5.05-7.292-4.523 7.599h8.872l-4.35-7.6zm-5.05 8.784v7.511h4.611l-4.61-7.51zm.307-.57h9.092l-4.35 7.73-4.743-7.73zm5.359 8.081H31l-4.656-7.51-4.348 7.51z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlct);
export default __webpack_public_path__ + "static/media/BLCT.6196ccceb6bf4b1d7fa5fc3bed03a483.svg";
export { ForwardRef as ReactComponent };